export default __webpack_public_path__ + "static/media/LT.48999dbb.svg";